import React, { Component } from 'react';
import { Carousel } from 'react-bootstrap';
import CarouselItems from '../../../shared/CarouselItems';

class Testimony extends Component {

  items = () => {
    return (
      CarouselItems.map(option => (
        <Carousel.Item className="carousel" key ={option.id}>
          <div className="row" style={{background:'#ebebeb'}}>
            <div className="col-md-5">
                <img
                  className="d-block"
                  src={ option.img }
                  alt="Imagen"
                />
            </div>                  
              <div className="col-md-7 pl-5 pt-4 pt-md-0" >
                  <h4 className="fuente-monserrat">{option.titulo}</h4>
                  <blockquote style ={{padding:0, borderLeft:0}} className="fuente-monserrat">
                    {option.tipo}
                  </blockquote>
                  <p className="fuente-monserrat">
                    {option.estudiante}
                  </p>
              </div>
          </div>
        </Carousel.Item>
      ))
    )
  }

  render() {
      return (
        <React.Fragment>
          <Carousel className="portfolio py-5">
            {this.items()}
          </Carousel>
        </React.Fragment>
      );
  }
}

export default Testimony;


// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Testimony.jsx